import { Grid, makeStyles } from '@material-ui/core'
import ArrowDropDownIcon from 'components/common/icons/ArrowDropDownIcon'
import ProfilePicture from 'components/common/ProfilePicture'
import DazzedHeading13 from 'components/common/text/DazzedHeading13'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import AppProfileMenu from 'components/Header/ProfileMenu/AppProfileMenu'
import { Roles } from 'consts/authConsts'
import useBroadcast from 'hooks/useBroadcast'
import { getCurrentAuthProfile } from 'logic/loginProfilesLogic'
import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { isUserOfRole } from 'utils/authUtils'
import { updateS3PracticeLogoKey } from 'utils/storageUtils'

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
    flexWrap: 'nowrap'
  },
  profilePicture: {
    margin: '0 10px'
  },
  nameAndPracticeName: {
    display: 'flex',
    flexDirection: 'column'
  },
  profileDetailsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    paddingRight: 10
  },
  profileName: {
    lineHeight: '18px'
  },
  practiceName: {
    lineHeight: '18px'
  },
  arrowIcon: {
    padding: '0 20px'
  }
}))

const AppMenuButton = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const { closeBroadcastMode } = useBroadcast()

  const practiceDetails = useSelector(state => state.practiceReducer.details)
  const practiceLogo = useMemo(
    () => practiceDetails?.logo && updateS3PracticeLogoKey(practiceDetails.logo),
    [practiceDetails.logo]
  )
  const currentAuthProfile = getCurrentAuthProfile()

  const handleClick = useCallback(
    event => {
      setAnchorEl(event.currentTarget)
      closeBroadcastMode('App Menu clicked')
    },
    [closeBroadcastMode]
  )

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <>
      <Grid id="header-menu" container className={classes.root} onClick={handleClick}>
        <ProfilePicture
          name={practiceDetails.practiceName}
          email={practiceDetails.email}
          photo={practiceLogo}
          isAdmin={isUserOfRole([Roles.Admin])}
          size="xsmall"
          className={classes.profilePicture}
        />
        <Grid container className={classes.profileDetailsContainer}>
          <Grid container className={classes.nameAndPracticeName}>
            <DazzedHeading14 id="header-menu-display-name" bold className={classes.profileName}>
              {currentAuthProfile?.displayName}
            </DazzedHeading14>
            <DazzedHeading13 id="header-menu-practice-name" regular className={classes.profileName}>
              {practiceDetails.practiceName}
            </DazzedHeading13>
          </Grid>
          <Grid item className={classes.arrowIcon}>
            <ArrowDropDownIcon />
          </Grid>
        </Grid>
      </Grid>
      <AppProfileMenu anchorEl={anchorEl} handleClose={handleClose} />
    </>
  )
}

export default AppMenuButton
